import React from 'react'
import style from './index.module.css'

export default function Footer() {
  return (
    <div>
      <div  className={style.footer}>

      <div className={style.ftr1}>
        <h5>Support</h5>
        <address>685 Market Street,Las Vegas, LA 95820,United States.</address>
        <p><i class="fa-solid fa-envelope"></i> example@domain.com</p>
        <p><i class="fa-solid fa-phone"></i> (+01) 850-315-5862</p>
      </div>
      <div className={style.ftr1}>
        <h5 className={style.acc}>Account</h5>
         <ul type='none'>
          <li><a href="#">My Account</a></li>
          <li><a href="#">Login/Registr</a></li>
          <li><a href="#">Cart</a></li>
          <li><a href="#">Wishlist</a></li>
          <li><a href="#">Shop</a></li>
         </ul>
      </div>
      <div className={style.ftr1}>
        <h5 className={style.quick}>Quick Link</h5>
         <ul type='none'>
          <li><a href="#">About</a></li>
          <li><a href="#">Contact</a></li>
          <div className={style.icon}>
            <a href=''><i class="fa-brands fa-facebook-f"></i></a>
            <a href=''><i class="fa-brands fa-instagram"></i></a>
            <a href=''><i class="fa-brands fa-twitter"></i></a>
            <a href=''><i class="fa-brands fa-invision"></i></a>
          </div>
         </ul>
      </div>
    </div>
    <div className={style.ftr2}>
        <p>© 2024. All rights reserved by Axilthemes.</p>
    </div>
  </div>
  )
}
